import { defineMessages } from 'react-intl-next';

export const messages: {
	externalPersonLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	externalPersonLabel: {
		id: 'search-result.user-mention.external-person',
		defaultMessage: 'External person',
		description: 'Label for external person in user mention',
	},
});
